import React from 'react';

function ServerCard({ server, onStart, onStop, onRestart, loading, isAdmin }) {
  const isRunning = server.docker_status?.running;
  const status = server.docker_status?.status || 'unknown';
  const statusLabel = status === 'exited'
    ? 'Stopped'
    : status.charAt(0).toUpperCase() + status.slice(1);
  const gameType = server.game_type.toLowerCase();
  const artwork = {
    minecraft: '/game-art/minecraft.png',
    hytale: '/game-art/hytale.png',
    azerothcore: '/game-art/azerothcore.png',
    wow: '/game-art/azerothcore.png',
    palworld: '/game-art/palworld.png',
  }[gameType];

  return (
    <div className={`server-card server-card-${gameType}`}>
      <div
        className={`server-artwork${artwork ? '' : ' server-artwork-generic'}`}
        style={artwork ? { backgroundImage: `url(${artwork})` } : undefined}
      >
        <div className="server-artwork-overlay">
          <div className="server-name">{server.name}</div>
          <span className={`server-type ${gameType}`}>
            {server.game_type}
          </span>
        </div>
      </div>

      <div className="server-card-content">
        {server.description && (
          <div className="server-description">{server.description}</div>
        )}

        <div className="server-status">
          <div className={`status-indicator ${isRunning ? 'running' : ''}`}></div>
          <span className="status-text">
            {isRunning ? 'Running' : statusLabel}
          </span>
        </div>

        {isRunning && server.docker_status?.players !== undefined && (
          <div className="server-players">
            👥 <strong>Players:</strong> {server.docker_status.players}
          </div>
        )}

        {server.port && (
          <div className="server-port">Port: {server.port}</div>
        )}

        {!isRunning && server.auto_shutdown_enabled === 1 && (
          <div className="server-auto-shutdown">
            ⏰ Auto-shutdown enabled
          </div>
        )}

        <div className="server-actions">
          {!isRunning ? (
            <button
              className="action-btn start"
              onClick={() => onStart(server.id)}
              disabled={loading}
            >
              {loading ? '...' : 'Start'}
            </button>
          ) : isAdmin ? (
            <>
              <button
                className="action-btn stop"
                onClick={() => onStop(server.id)}
                disabled={loading}
              >
                {loading ? '...' : 'Stop'}
              </button>
              <button
                className="action-btn restart"
                onClick={() => onRestart(server.id)}
                disabled={loading}
              >
                {loading ? '...' : 'Restart'}
              </button>
            </>
          ) : (
            <div className="server-running-message">
              <strong>Server Running</strong>
              <div>Ready to join</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ServerCard;
